module.exports = "//static.hsappstatic.net/ecosystem-marketplace-apps-base/static-1.8387/img/video-thumb-overlay.png"